export var serializeProbe = function (probe) {
    var _a;
    return {
        _type: 'if',
        probe: {
            _type: 'catalog',
            probeAmplifierId: ((_a = probe.probeAmplifier) === null || _a === void 0 ? void 0 : _a.id) || -1
        },
        scaleUgram: probe.scale.ugram,
        index: 1
    };
};
export var serializeBuffers = function (buffers, legacy) { return ({
    _type: 'if',
    antibodyBufferMl: buffers.antibody.valueMl,
    amplificationBufferMl: buffers.amplification.valueMl,
    goldAmpWashBufferMl: !legacy ? buffers.goldAmpWash.valueMl : 0,
    index: 1
}); };
//# sourceMappingURL=KitSerialization.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/ihc2/KitSerialization.js
// module id = 1085
// module chunks = 0